import React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import {
  Description,
  Title,
  Wrapper,
} from './cardWithTitleAndDescription.styles';

interface IProps {
  title: Array<RichTextBlock>;
  description: Array<RichTextBlock>;
}

export const CardWithTitleAndDescription = ({ title, description }: IProps) => {
  return (
    <Wrapper>
      <Title>{RichText.asText(title)}</Title>
      <Description>{RichText.asText(description)}</Description>
    </Wrapper>
  );
};
